"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = require("@jsluna/button");

var _icons = require("@jsluna/icons");

var _Slide = _interopRequireDefault(require("./Slide"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Lightbox = function Lightbox(_ref) {
  var open = _ref.open,
      media = _ref.media,
      onClose = _ref.onClose,
      selection = _ref.selection;

  var _useState = (0, _react.useState)(selection),
      position = _useState[0],
      setPosition = _useState[1];

  (0, _react.useEffect)(function () {
    setPosition(selection);
  }, [selection]);

  var selectPrevious = function selectPrevious() {
    return setPosition(position > 0 ? position - 1 : 0);
  };

  var selectNext = function selectNext() {
    return setPosition(position < media.length ? position + 1 : 0);
  };

  var imageMedia = media.filter(function (x) {
    return x.type === 'image';
  });
  return open && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "lightbox"
  }, /*#__PURE__*/_react.default.createElement(_button.CancelButton, {
    className: "lightbox-close",
    onClick: onClose
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "lightbox-content"
  }, /*#__PURE__*/_react.default.createElement(_Slide.default, {
    slide: imageMedia[position],
    length: imageMedia.length,
    index: position + 1
  })), position !== 0 && /*#__PURE__*/_react.default.createElement(_button.FilledButton, {
    className: "previous",
    onClick: selectPrevious
  }, /*#__PURE__*/_react.default.createElement(_icons.ArrowLeft, null)), position < imageMedia.length - 1 && /*#__PURE__*/_react.default.createElement(_button.FilledButton, {
    className: "next",
    onClick: selectNext
  }, /*#__PURE__*/_react.default.createElement(_icons.ArrowRight, null))));
};

Lightbox.propTypes = {
  open: _propTypes.default.bool,
  selection: _propTypes.default.number,
  onClose: _propTypes.default.func.isRequired,
  media: _propTypes.default.arrayOf(_propTypes.default.shape({
    imageUrl: _propTypes.default.string.isRequired,
    imageTitle: _propTypes.default.string.isRequired,
    imageDescription: _propTypes.default.string
  }))
};
Lightbox.defaultProps = {
  selection: 0,
  open: false,
  media: []
};
var _default = Lightbox;
exports.default = _default;